export interface OnExchangeEnrollPersonI {
  id: number; // This is added to mimick the DOJO.MEMORY store and to align with existing copied code; probably needs removed from payloads
  fullName: {
    firstName: string;
    middleName: string;
    lastName: string;
    suffix: string;
  };
  relationship: string;
  relationshipCode: string;
  ssn: {
    ssnNumber: string;
    noSsnInd: string;
  };
  gender: string;
  dateOfBirth: string;
  homeAddress: {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipcode: string;
    county: string;
    countyCode: string;
  };
  sameAddressAsSubscriber: string;
  sameMailingAddress: string;
  mailingAddress: {
    addressLine1: string;
    addressLine2: string;
    city: string;
    state: string;
    zipcode: string;
    county: string;
    countyCode: string;
  };
  primaryPhoneNumber: string;
  otherPhoneNumber: string;
  tobaccoInd: boolean | string;
  tobaccoLastUsed: string;
  tobaccoDate?: string; // I see this in the person-presenter.service, but did not see it in my existing payload responses
  receiveVia: {
    electronically: string;
    mail: string;
  };
  email: string;
  emailInd: string;
  cellNumber: string;
  cellNumberInd: string;
  spokenLanguage: string;
  spokenLanguageCode: string;
  readingLanguage: string;
  readingLanguageCode: string;
  specialAssistance: string;
  eSignature: string;
  guardianFullName: {
    firstName: string;
    middleName: string;
    lastName: string;
  };
  pcp: {
    name: string;
    number: string;
    pcpInd: string;
  };
}

export class OnExchangeEnrollPerson implements OnExchangeEnrollPersonI {
  'id': null;
  'fullName': {
    firstName: null;
    middleName: null;
    lastName: null;
    suffix: null;
  };
  'relationship' = null;
  'relationshipCode' = null;
  'ssn': { ssnNumber: null; noSsnInd: null };
  'gender' = null;
  'dateOfBirth' = null;
  'homeAddress': {
    addressLine1: null;
    addressLine2: null;
    city: null;
    state: null;
    zipcode: null;
    county: null;
    countyCode: null;
  };
  'sameAddressAsSubscriber' = null;
  'sameMailingAddress' = null;
  'mailingAddress': {
    addressLine1: null;
    addressLine2: null;
    city: null;
    state: null;
    zipcode: null;
    county: null;
    countyCode: null;
  };
  'primaryPhoneNumber' = null;
  'otherPhoneNumber' = null;
  'tobaccoInd' = null;
  'tobaccoLastUsed' = null;
  'receiveVia': { electronically: null; mail: null };
  'email' = null;
  'emailInd' = null;
  'cellNumber' = null;
  'cellNumberInd' = null;
  'spokenLanguage' = null;
  'spokenLanguageCode' = null;
  'readingLanguage' = null;
  'readingLanguageCode' = null;
  'specialAssistance' = null;
  'eSignature' = null;
  'guardianFullName': {
    firstName: null;
    middleName: null;
    lastName: null;
  };
  'pcp': { name: string; number: string; pcpInd: string };

  constructor() {}
}

export interface Family {
  persons: OnExchangeEnrollPersonI[];
}
